import { createContext } from "react";

const IncomingOrderConceptContext = createContext();

export default IncomingOrderConceptContext;
